import { useCallback, useState } from 'react'

import { useSelection, type Selection } from '@/components/selection'

export interface SelectionMode {
  selection: Selection<number>
  /** True while the list shows checkboxes, even with nothing ticked yet. */
  active: boolean
  start: () => void
  exit: () => void
}

/**
 * Selection mode for a library list.
 *
 * `useSelection` only turns itself on when something is selected, but the
 * toolbar's "Select" button has to open an empty selection. That extra flag is
 * the whole reason this exists; `exit` puts both halves back.
 */
export function useSelectionMode(): SelectionMode {
  const selection = useSelection<number>()
  const [opened, setOpened] = useState(false)

  const start = useCallback(() => setOpened(true), [])
  const clear = selection.clear

  const exit = useCallback(() => {
    setOpened(false)
    clear()
  }, [clear])

  return { selection, active: opened || selection.active, start, exit }
}
